import React, { useState } from "react";
import {
  Button,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledDropdown,
} from "reactstrap";
import FontAwesomeIcon from "../../helpers/fontawesome/fontAwesome";
import NumberFormat from "react-number-format";
import moment from "moment";

const PeriodListItem = ({
  mutate,
  title,
  alternativeName,
  onDeleteAction,
  onEditAction,
  options,
  createdAt,
  start_at,
  end_at,
  discount_total,
  discount_percentage,
  discount_due_date,
  owner_name,
  owner_dni,
  account_number,
  ...rest
}) => {
  const [collapseOne, collapseOneOpen] = useState(false);
  const [nameValidation, setNameValidation] = useState(null);

  const handleDropdownAction = (action) => {
    if (action === "edit") {
      onEditAction(rest);
      return;
    }
    if (action === "delete") return collapseOneOpen(true);
    throw new Error("invalid action");
  };

  const handleDelete = () => {
    collapseOneOpen(false);
    onDeleteAction(rest);
  };

  const validateCondominiumNameOnDelete = () => {
    return nameValidation === title;
  };

  const handleModal = () => (
    <Modal isOpen={collapseOne} data-testid="modal">
      <ModalHeader>Eliminar {title}</ModalHeader>
      <ModalBody>
        <p className="mb-0 font-weight-bold fs--1">
          Para continuar ingresa el nombre del {alternativeName} {title}
        </p>
        <FormGroup className="mt-1">
          <Input
            data-testid="validation-input"
            type="text"
            name="condominiumname"
            placeholder="Nombre"
            onChange={(e) => setNameValidation(e.target.value)}
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => collapseOneOpen(!collapseOne)}>Cancelar</Button>
        <Button
          data-testid="delete-button"
          disabled={!validateCondominiumNameOnDelete()}
          color="danger"
          onClick={handleDelete}
        >
          Eliminar
        </Button>
      </ModalFooter>
    </Modal>
  );

  return (
    <>
      <tr>
        <td>
          <b>{title}</b>
        </td>
        <td className="text-center">{moment(start_at).format("DD/MM/YYYY")}</td>
        <td className="text-center">{moment(end_at).format("DD/MM/YYYY")}</td>
        <td className="text-center">
          {moment(createdAt).format("DD/MM/YYYY")}
        </td>
        <td className="text-center">
          {Number(discount_percentage) > 0 && discount_due_date ? (
            <span className="text-success font-weight-bold">
              {discount_percentage}% (hasta {moment(discount_due_date).format("DD/MM/YYYY")})
            </span>
          ) : discount_total ? (
            <NumberFormat
              value={discount_total}
              displayType="text"
              thousandSeparator
              decimalScale={2}
              fixedDecimalScale
              prefix="$ "
            />
          ) : (
            "—"
          )}
        </td>
        {options && (
          <td className="text-right align-middle">
            {(onEditAction || onDeleteAction) && (
            <UncontrolledDropdown>
              <DropdownToggle color="link" size="sm" className="text-600 btn-reveal">
                <FontAwesomeIcon icon="ellipsis-h" className="fs--1" />
              </DropdownToggle>
              <DropdownMenu right className="border py-0">
                <div className="bg-white py-2">
                  {onEditAction && (
                    <DropdownItem onClick={onEditAction}>
                      Editar
                    </DropdownItem>
                  )}
                  {onDeleteAction && (
                    <DropdownItem className="text-danger" onClick={() => handleDropdownAction("delete")}>
                      Eliminar
                    </DropdownItem>
                  )}
                </div>
              </DropdownMenu>
            </UncontrolledDropdown>
            )}
          </td>
        )}
      </tr>
      {handleModal()}
    </>
  );
};

export default PeriodListItem;
